import React from 'react'
import BarraPrincipal from '../Modulos/BarraPrincipal';
import './Css/principalResponsive.css';

class Principal extends React.Component {
    componentDidMount() {
        document.body.classList.add('principal-responsive-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('principal-responsive-page');
    }

    toggleNavigationMenu = () => {
        const sideNavToggle = document.querySelector('[class*="sidenav-toggle"]');
        sideNavToggle?.click();
    };

    render() {
    return (
        <>
            <div className="layout-wrapper layout-content-navbar principal-page">
                <div className="layout-container">
                    <div className="layout-page">
                        <div className="principal-navbar-wrap">
                            <BarraPrincipal onToggleNavigation={this.toggleNavigationMenu} />
                        </div>
                        <div className="img-wrapper">
                            <img src='./WebInicio.png' className="background-img" alt="Infocarga" />
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
    }
}

export default Principal
